import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { match } from 'react-router-dom';

// Components
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas } from '../../../local-types';
// Modules
// import { DispatchGroup } from '../../../redux/reducers/api-types';
// import { actions as driverActions, selectors as driverSelectors } from '../../../redux/reducers/drivers';
import { ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import { actions as partnerActions, types as partnerTypes } from '../../../redux/reducers/partners';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
import { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';
import { TParams } from '../../../redux/reducers/api-types';

interface PartnerAddDriverPageProps extends WithTranslation {
    match: match<TParams>;
    // dispatchGroups: DispatchGroup[];
    savePartnerDriverError: ErrorPayload;
    saveDriver: (id: string, payload: any) => void;
    isSavingDriver: boolean;
    // getDispatchGroups: () => void;
}

interface PartnerAddDriverPageState {
    formData: any;
}

class PartnerAddDriverPage extends React.Component<PartnerAddDriverPageProps, PartnerAddDriverPageState> {
    constructor(props: PartnerAddDriverPageProps) {
        super(props);
        const { match } = props;
        const id = match.params.id;
        this.state = {
            formData: {
                the_dispatch_groups: { normal: false },
                dispatch_groups: ['normal'],
                firstname: '',
                lastname: '',
                email: '',
                phone_number: '',
                driving_licence_number: '',
                driving_licence_attachment_write: '',
                partner_id: id,
            },
        };
    }

    componentDidMount() {
        // const { dispatchGroups } = this.props;
        // if (dispatchGroups.length === 0) {
        //     this.props.getDispatchGroups();
        // }
    }

    //========================================//
    //=============== Builders ===============//
    //========================================//

    generateInputs = (): FormDatas[] => {
        const { t } = this.props;
        // if (dispatchGroups.length <= 0) {
        //     return [];
        // }
        const inputs: FormDatas[] = [
            {
                title: t('add_driver.title'),
                sectionStyle: { flex: 1 },
                datas: [
                    { id: 'lastname', label: t('common:form.lastname'), required: true },
                    {
                        id: 'firstname',
                        label: t('common:form.firstname'),
                        required: true,
                    },
                    {
                        id: 'email',
                        label: t('common:form.email'),
                        hint: t('common:form.email_hint'),
                        type: 'email',
                        required: true,
                    },
                    {
                        id: 'phone_number',
                        label: t('common:form.phone_number'),
                        hint: t('common:form.phone_number_hint'),
                        type: 'tel',
                        required: true,
                    },
                    {
                        id: 'driving_licence_number',
                        label: t('add_driver.driver_licence_number'),
                        required: true,
                    },
                    {
                        id: 'driving_licence_attachment_write',
                        label: t('add_driver.driver_licence'),
                        type: 'file',
                        required: true,
                    },
                    {
                        id: 'the_dispatch_groups.normal',
                        label: t('add_driver.can_be_berline'),
                        type: 'boolean',
                    },
                    // {
                    //     id: 'dispatch_groups',
                    //     label: t('add_driver.courses_type'),
                    //     boxes: dispatchGroups,
                    // },
                ],
            },
        ];
        return inputs;
    };

    onSubmitPartnerDriverAdd = (formData: any, event, stringify: any, keepFormData: any): void => {
        const { match, saveDriver } = this.props;
        const id = match.params.id;
        let data = formData;

        if (formData.driving_licence_attachment_write) {
            data = stringify;

            data.append('the_dispatch_groups', JSON.stringify(formData.the_dispatch_groups));
            data.append(
                'dispatch_groups',
                JSON.stringify(formData.dispatch_groups.filter((dg) => formData.the_dispatch_groups[dg])),
            );
            data.append('partner_id', (this.props.match.params as any).id);
        }
        this.setState({
            formData: keepFormData,
        });

        saveDriver(id, data);
    };

    render() {
        const { formData } = this.state;
        const { match, savePartnerDriverError, isSavingDriver } = this.props;
        const id = match.params.id;

        return (
            <App needRights={{ name: AccountRight.PARTNER_SETTINGS, mode: RightRank.W }}>
                <ErrorMessage payload={savePartnerDriverError} />
                <EnhancedForm
                    payload={formData}
                    inputs={this.generateInputs()}
                    backRoute={`${paths.partners}/${id}`}
                    onSubmit={this.onSubmitPartnerDriverAdd}
                    loader={isSavingDriver}
                />
            </App>
        );
    }
}

const PartnerAddDriverPageWithTranslation = withTranslation(['partner', 'common'])(PartnerAddDriverPage);

const mapStateToProps = (state) => ({
    // dispatchGroups: driverSelectors.sortedDispatchGroup(state),
    savePartnerDriverError: errorSelectors.savePartnerDriverError(state),
    isSavingDriver: pendingSelectors.isPending(state, partnerTypes.SAVE_PARTNER_DRIVER),
});

const mapDispatchToProps = {
    saveDriver: partnerActions.saveDriver,
    // getDispatchGroups: driverActions.getDispatchGroups,
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerAddDriverPageWithTranslation);
